<div
        class="ui-g-12 ui-lg-12 text-right"
        style="float:unset;">
    <button pButton type="button"
            class="k-generic-btn"
            icon="fa fa-angle-left"
            iconPos="left"
            (click)="customButton()"
            label="{{ 'common.back' | translate }}"></button>
</div>

<app-kontable
        id="dt_roles_permissions"
        [title] = "'roleMS.listPermissionsTitle' | translate"
        [columns] = "['operationID', 'type', 'operationName',
            {field: 'allowsDELETE', bodyTemplate: getField, title: 'permissionForm.allowsGET', filterTemplate: noFilter, filterType: customFilter},
            {field: 'allowsDELETE', bodyTemplate: postField, title: 'permissionForm.allowsPOST', filterTemplate: noFilter, filterType: customFilter},
            {field: 'allowsDELETE', bodyTemplate: putField, title: 'permissionForm.allowsPUT', filterTemplate: noFilter, filterType: customFilter},
            {field: 'allowsDELETE', bodyTemplate: deleteField, title: 'permissionForm.allowsDELETE', filterTemplate: noFilter, filterType: customFilter},
            'order_index'
        ]"
        [titles] = "['permissionForm.operationID', 'permissionForm.type', 'permissionForm.operationName', 'permissionForm.orderIndex']"
        [source] = "srvRolePermissionMS.currentRolePermissions"
        [paginationType]="paginationType"
        [showGlobalFilter]="false"
        [showDetailsButton]="false"
        [showInfoButton]="false"
        [showAddButton]="true"
        [(fireNewDataAvailable)]="newDataAvailable"
        (onEdit)="editPermissionRole($event)"
        (onAdd)="editPermissionRole({})"
        (onRemove)="remove($event)">
    <ng-template #getField data-testid="getField" let-row let-value="value"><i class="pi {{returnValueClumn (row, 'get')}}"></i></ng-template>
    <ng-template #postField data-testid="postField" let-row let-value="value"><i class="pi {{returnValueClumn (row, 'post')}}"></i></ng-template>
    <ng-template #putField data-testid="putField" let-row let-value="value"><i class="pi {{returnValueClumn (row, 'put')}}"></i></ng-template>
    <ng-template #deleteField data-testid="deleteField" let-row let-value="value"><i class="pi {{returnValueClumn (row, 'delete')}}"></i></ng-template>
    <ng-template #noFilter data-testid="noFilter" let-col></ng-template>
</app-kontable>

<p-dialog
        *ngIf="showDetail"
        [width]="600"
        [(visible)]="showDetail"
        [responsive]="true"
        [draggable]="false"
        [resizable]="false"
        showEffect="fade"
        (onHide)="closeDialogDetail()"
        [modal]="true">
    <app-rolesapplicationpermission-form
            *ngIf="showDetail"
            [rolePermission]="selectedPermissionRoleMS"
            [selectedRole]="role"
            (onSave)="save($event)"
    ></app-rolesapplicationpermission-form>
</p-dialog>



// WEBPACK FOOTER //
// ./src/app/views/administration/rolesApplication/rolesApplicationPermissions.component.html